import {
  Bell,
  BookCopy,
  BookMarked,
  BookOpen,
  Brain,
  Calendar,
  ClipboardCheck,
  FileText,
  GraduationCap,
  Home,
  MessageSquare,
  PenTool,
  Users,
} from 'lucide-react';
import type { RouteConfig } from '../types';
import {
  PaidFees,
  StudentAnnouncements,
  StudentAssessments,
  StudentCalendar,
  StudentDashboard,
  StudentFinalGrades,
  StudentLeaves,
  StudentModules,
  StudentOpenAssessment,
  StudentPeople,
  StudentPreviousExams,
  StudentProfile,
  StudentQuiz,
  StudentReportCard,
  StudentSoa,
  StudentSubjectAnnouncements,
  StudentSubjectGrades,
  StudentSubjectHome,
  StudentSubjects,
  StudentSyllabus,
  StudentTeacherMessages,
  StudentViewAttendance,
  TempPage,
} from './lazy-components';
export const studentBothRoutes: Record<'home' | 'subject', RouteConfig[]> = {
  home: [
    {
      isLabel: true,
      name: 'Personal',
      showOnSideBar: true,
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      icon: Home,
      showOnSideBar: true,
      component: StudentDashboard,
      isCombobox: true,
      breadcrumb: {
        title: 'Dashboard',
        parent: null,
      },
    },
    {
      path: '/successful-subscription',
      name: 'Successful Subscription',
      showOnSideBar: false,
      component: TempPage,
      isCombobox: false,
      breadcrumb: {
        title: 'Successful Subscription',
        parent: '/dashboard',
      },
    },
    {
      path: '/announcements',
      name: 'Announcements',
      icon: Bell,
      showOnSideBar: true,
      component: StudentAnnouncements,
      isCombobox: true,
      breadcrumb: {
        title: 'Announcements',
        parent: '/dashboard',
      },
    },
    {
      path: '/teacher-messages',
      name: 'Teacher Messages',
      icon: MessageSquare,
      showOnSideBar: true,
      component: StudentTeacherMessages,
      isCombobox: true,
      breadcrumb: {
        title: 'Teacher Messages',
        parent: '/dashboard',
      },
    },
    {
      path: '/general-school-calendar',
      name: 'School Calendar',
      icon: Calendar,
      showOnSideBar: true,
      component: StudentCalendar,
      isCombobox: true,
      breadcrumb: {
        title: 'School Calendar',
        parent: '/dashboard',
      },
    },
    {
      path: '/profile',
      name: 'Profile',
      showOnSideBar: false,
      component: StudentProfile,
      isCombobox: false,
      breadcrumb: {
        title: 'Profile',
        parent: '/dashboard',
      },
    },
    {
      isLabel: true,
      name: 'Academics',
      showOnSideBar: true,
    },
    {
      path: '/subjects/all',
      name: 'My Subjects',
      icon: BookOpen,
      showOnSideBar: true,
      component: StudentSubjects,
      isCombobox: true,
      breadcrumb: {
        title: 'My Subjects',
        parent: '/dashboard',
      },
    },
    {
      path: '/subjects/home/:subjectId',
      name: 'Subject Home',
      showOnSideBar: false,
      component: StudentSubjectHome,
      isCombobox: false,
      breadcrumb: {
        title: 'Subject Home',
        parent: '/subjects/all',
      },
    },
    {
      path: '/view-attendance',
      name: 'Attendance',
      icon: ClipboardCheck,
      showOnSideBar: true,
      component: StudentViewAttendance,
      isCombobox: true,
      breadcrumb: {
        title: 'Attendance',
        parent: '/dashboard',
      },
    },

    {
      path: '/my-grades',
      name: 'Grades',
      icon: GraduationCap,
      showOnSideBar: true,
      component: StudentFinalGrades,
      isCombobox: true,
      breadcrumb: {
        title: 'Grades',
        parent: '/dashboard',
      },
    },
    {
      path: '/report-card/:schoolYearId',
      name: 'Report Card',
      showOnSideBar: false,
      component: StudentReportCard,
      isCombobox: false,
      breadcrumb: {
        title: 'Report Card',
        parent: '/my-grades',
      },
    },
    {
      path: '/previous-exams',
      name: 'Previous Exams',
      icon: BookCopy,
      showOnSideBar: true,
      component: StudentPreviousExams,
      isCombobox: true,
      breadcrumb: {
        title: 'Previous Exams',
        parent: '/dashboard',
      },
    },
    {
      isLabel: true,
      name: 'MISCELLANEOUS',
      showOnSideBar: true,
    },
    {
      path: '/library',
      name: 'Library',
      icon: BookMarked,
      showOnSideBar: true,
      component: TempPage,
      isCombobox: true,
      breadcrumb: {
        title: 'Library',
        parent: '/dashboard',
      },
    },
    {
      path: '/leave-application',
      name: 'Leave Application',
      icon: Calendar,
      showOnSideBar: true,
      component: StudentLeaves,
      isCombobox: true,
      breadcrumb: {
        title: 'Leave Application',
        parent: '/dashboard',
      },
    },
    {
      isGroup: true,
      groupName: 'Finance',
      name: 'Finance',
      icon: FileText,
      showOnSideBar: true,
      state: 'financepages',
      children: [
        {
          path: '/paid-fees',
          name: 'Statement of Account',
          icon: FileText,
          showOnSideBar: true,
          component: StudentSoa,
          isCombobox: true,
          breadcrumb: {
            title: 'Statement of Account',
            parent: '/dashboard',
          },
        },
        {
          path: '/paid-fees/statement-of-account/:soaId',
          name: 'View Statement',
          showOnSideBar: false,
          component: PaidFees,
          isCombobox: false,
          breadcrumb: {
            title: 'View Statement',
            parent: '/paid-fees',
          },
        },
      ],
    },
  ],
  subject: [
    {
      isLabel: true,
      name: 'Navigation',
      showOnSideBar: true,
    },
    {
      path: '/dashboard',
      name: 'Back to Dashboard',
      icon: Home,
      showOnSideBar: true,
      component: StudentDashboard,
      isCombobox: true,
      breadcrumb: {
        title: 'Dashboard',
        parent: null,
      },
    },
    {
      path: '/subjects/all',
      name: 'All Subjects',
      icon: BookOpen,
      showOnSideBar: true,
      component: StudentSubjects,
      isCombobox: true,
      breadcrumb: {
        title: 'All Subjects',
        parent: '/dashboard',
      },
    },
    {
      isLabel: true,
      name: 'Subject Content',
      showOnSideBar: true,
    },
    {
      path: '/subjects/home/:subjectId',
      name: 'Subject Home',
      icon: Home,
      showOnSideBar: true,
      component: TempPage,
      isCombobox: true,
      breadcrumb: {
        title: 'Subject Home',
        parent: '/subjects/all',
      },
    },
    {
      path: '/subjects/announcements/:subjectId',
      name: 'Announcements',
      icon: Bell,
      showOnSideBar: true,
      component: StudentSubjectAnnouncements,
      isCombobox: true,
      breadcrumb: {
        title: 'Announcements',
        parent: '/subjects/home/:subjectId',
      },
    },
    {
      path: '/subjects/grading/:subjectId',
      name: 'Grades',
      icon: GraduationCap,
      showOnSideBar: true,
      component: StudentSubjectGrades,
      isCombobox: true,
      breadcrumb: {
        title: 'Grades',
        parent: '/subjects/home/:subjectId',
      },
    },
    {
      path: '/subjects/my-students/:subjectId',
      name: 'People',
      icon: Users,
      showOnSideBar: true,
      component: StudentPeople,
      isCombobox: true,
      breadcrumb: {
        title: 'People',
        parent: '/subjects/home/:subjectId',
      },
    },
    {
      path: '/subjects/syllabus/:subjectId',
      name: 'Syllabus',
      icon: BookCopy,
      showOnSideBar: true,
      component: StudentSyllabus,
      isCombobox: true,
      breadcrumb: {
        title: 'Syllabus',
        parent: '/subjects/home/:subjectId',
      },
    },
    {
      path: '/subjects/modules/:subjectId',
      name: 'Modules',
      icon: Brain,
      showOnSideBar: true,
      component: StudentModules,
      isCombobox: true,
      breadcrumb: {
        title: 'Modules',
        parent: '/subjects/home/:subjectId',
      },
    },
    {
      path: '/subjects/assessments/:subjectId',
      name: 'Assessments',
      icon: ClipboardCheck,
      showOnSideBar: true,
      component: StudentAssessments,
      isCombobox: true,
      breadcrumb: {
        title: 'Assessments',
        parent: '/subjects/home/:subjectId',
      },
    },
    {
      path: '/subjects/:subjectId/assessments/student/assessment/:assessmentId',
      name: 'Submit Assessment',
      showOnSideBar: false,
      component: StudentOpenAssessment,
      isCombobox: false,
      breadcrumb: {
        title: 'Submit Assessment',
        parent: '/subjects/assessments/:subjectId',
      },
    },
    {
      path: '/subjects/projects/student/project/:id',
      name: 'Submit Project',
      showOnSideBar: false,
      component: TempPage,
      isCombobox: false,
      breadcrumb: {
        title: 'Submit Project',
        parent: '/subjects/home/:subjectId',
      },
    },
    {
      path: '/subjects/quizzes',
      name: 'Quizzes',
      icon: PenTool,
      showOnSideBar: true,
      component: StudentQuiz,
      isCombobox: true,
      breadcrumb: {
        title: 'Quizzes',
        parent: '/subjects/home/:subjectId',
      },
    },
    {
      path: '/subjects/quizzes/:quizId',
      name: 'Take Quiz',
      showOnSideBar: false,
      component: TempPage,
      isCombobox: false,
      breadcrumb: {
        title: 'Take Quiz',
        parent: '/subjects/quizzes',
      },
    },
    {
      path: '/subjects/quiz-details/:quizId',
      name: 'Quiz Start',
      showOnSideBar: false,
      component: TempPage,
      isCombobox: false,
      breadcrumb: {
        title: 'Quiz Start',
        parent: '/subjects/quizzes/:quizId',
      },
    },
    {
      path: '/subjects/quizzes-result/:quizId',
      name: 'Quiz Result',
      showOnSideBar: false,
      component: TempPage,
      isCombobox: false,
      breadcrumb: {
        title: 'Quiz Result',
        parent: '/subjects/quizzes/:quizId',
      },
    },
  ],
};

export const studentRoutes = [...studentBothRoutes.home, ...studentBothRoutes.subject];
